import { IContainerStrategy } from '../ContainerStrategy'
import {
    AttributeDefinitionType,
    ContainerDataType,
    ContainerType,
    Conversationsv2DataType,
    TaskConfigType,
    UpdatedAttributesData,
    UpdatedQCAttributesData,
    UpdatedValueDataType,
} from 'Types/Tasks.types'
import { cloneDeep, isEmpty } from 'lodash'
import { ConversationTaskv2 } from 'Tasks/ConversationTaskv2/ConversationTaskv2'

export class Conversationv2ContainerStrategy
    implements IContainerStrategy<ContainerType.Conversationsv2, Conversationsv2DataType>
{
    containerContext?: {
        task: ConversationTaskv2
    }

    setContext(containerContext: { task: ConversationTaskv2 }) {
        this.containerContext = containerContext
    }

    getEmptyDraftContainer(): ContainerDataType<
        ContainerType.Conversationsv2,
        Conversationsv2DataType
    > {
        return {
            data: {
                type: ContainerType.Conversationsv2,
                schema_version: 1,
                data: {
                    response: {
                        id: '',
                        is_complete: false,
                        version_id: '',
                        main_info: {
                            value: {
                                turns_data: [],
                                json_attributes: {},
                            },
                            value_type: 'JSON',
                        },
                        extra_info: {},
                    },
                    quality_check: {
                        evaluation_on_response_version_id: null,
                    },
                },
            },
        }
    }

    getContainerFromOutputStart(
        outputStartContainer: ContainerDataType<
            ContainerType.Conversationsv2,
            Conversationsv2DataType
        >
    ): ContainerDataType<ContainerType.Conversationsv2, Conversationsv2DataType> {
        const draftContainer = cloneDeep(outputStartContainer)

        if (isEmpty(draftContainer.data.data.response.extra_info)) {
            draftContainer.data.data.response.extra_info = {}
        }

        draftContainer.data.data.quality_check.evaluation_on_response_version_id = {}

        return draftContainer
    }

    getModifiedDraftOutputContainer = (
        draftOutputContainer: ContainerDataType<
            ContainerType.Conversationsv2,
            Conversationsv2DataType
        >,
        taskConfig: TaskConfigType<ContainerType.Conversationsv2, Conversationsv2DataType>
    ) => {
        if (!this.containerContext?.task) {
            throw new Error('Task context not found')
        }
        const draftContainer = cloneDeep(draftOutputContainer)
        const data = draftContainer.data.data

        const extraInfo: UpdatedAttributesData = {}
        const qcAttributes: { [versionId: string]: UpdatedQCAttributesData } = {}

        const versionIds = Object.keys(data.quality_check.evaluation_on_response_version_id ?? {})

        taskConfig.assignment.task.attributes.forEach(attribute => {
            if (
                draftContainer.data.data.response.extra_info?.[attribute.name] &&
                attribute.type === AttributeDefinitionType.EXTRA_INFO
            ) {
                extraInfo[attribute.name] = draftContainer.data.data.response.extra_info?.[
                    attribute.name
                ] as UpdatedValueDataType<never>
            }

            versionIds.forEach(versionId => {
                if (
                    draftContainer.data.data.quality_check.evaluation_on_response_version_id?.[
                        versionId
                    ]?.[attribute.name] &&
                    attribute.type === AttributeDefinitionType.QUALITY_EVALUATION
                ) {
                    qcAttributes[versionId] = {
                        ...qcAttributes[versionId],
                        [attribute.name]:
                            draftContainer.data.data.quality_check
                                .evaluation_on_response_version_id[versionId][attribute.name],
                    } as UpdatedQCAttributesData
                }
            })
        })

        draftContainer.data.data.response.extra_info = extraInfo
        draftContainer.data.data.quality_check.evaluation_on_response_version_id = qcAttributes

        draftContainer.data.data.response.id = isEmpty(data.response.id)
            ? crypto.randomUUID()
            : data.response.id
        draftContainer.data.data.response.version_id = isEmpty(data.response.id)
            ? null
            : data.response.version_id

        return draftContainer
    }
}
